export default
{
    name: 'app-header',

    data()
    {
        return {

        }
    },

    computed:
    {
        content()
        {
            return this.$root.contentPage.menu.acf
        },

        menuIsOpen()
        {
            return this.$root.menuIsOpen
        },

        menuMobileIsOpen()
        {
            return this.$root.menuMobileIsOpen
        }
    },

    created()
    {
        this.eventHub.$on('window:resize', this._onResize)
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this._onResize)
    },

    methods:
    {
        // Events
        _onResize()
        {
            this.eventHub.$emit('app-header:resized')
        },

        // HTML Actions
        _clickOnRestaurants()
        {
            const action = this.menuIsOpen ? 'close' : 'open'
            this.eventHub.$emit(`menu:${action}`)
        },

        _onClickOnMenuBurger()
        {
            if (this.menuMobileIsOpen
                && this.menuIsOpen)
            {
                this.eventHub.$emit('menu:close')
            }
            else if (this.menuMobileIsOpen
                && !this.menuIsOpen)
            {
                this.eventHub.$emit('menu-mobile:close')
            }
            else if (!this.menuMobileIsOpen
                && !this.menuIsOpen)
            {
                this.eventHub.$emit('menu-mobile:open')
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-header/script.js